import React from 'react';
import useAsync from 'react-use/esm/useAsync';
import { InfoCard, Progress, ResponseErrorPanel } from '@backstage/core-components';

export const SolanaLatestBlock = () => {
  const { value, loading, error } = useAsync(async () => {
    // Запрос к публичному Solana RPC
    const res = await fetch('https://solana-rpc.publicnode.com', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        jsonrpc: '2.0',
        id: 1,
        method: 'getBlockHeight',
      }),
    });

    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    const data = await res.json();

    if (!data.result) {
      throw new Error(`No result returned from Solana RPC: ${JSON.stringify(data)}`);
    }

    return data.result;
  }, []);

  if (loading) return <Progress />;
  if (error) return <ResponseErrorPanel error={error} />;

  return (
    <InfoCard title="Solana Latest Block">
      <h2>{value}</h2>
    </InfoCard>
  );
};

